import { WestpacEnvironment } from 'global-types';

export const environment: WestpacEnvironment = {
  production: true,
  env: 'production',
  nydusNetworkApiBaseUrl: 'https://stg-nn.kaligo.com',
  translationBaseUrl: './assets/i18n',
  guardhouseApiUrl: 'https://myofferssso.stgeorge.com.au',
  clientId: '7165f30a-4c0b-487e-8021-f21f69fdc93a',
  connection: 'westpac',
  scope: 'openid,address,email,phone,profile,custom',
  redirectUri: 'https://myoffers.stgeorge.com.au',
  stripeApiKey:
    'pk_live_51I3Ys9LXeLt2fiomdRC4oR5TXEARjEI5Lg5NzAO81980KWASiSJHE8DfiO5Zn91ELirdFg0IKG3P8w0eNF7qrmz300i3Ket73A',
  travelEdgeBaseUrl: 'https://myoffershotels.stgeorge.com.au',
  brandName: 'St.George Bank',
  shortBrandName: 'STG',
  hermesMode: 'refresh-token-rotation',
  idleCheckConfig: {
    timeout: 600,
    promptTimeout: 120,
  },
  sessionCheckPollInterval: 180,
  sessionCheckRetryThreshold: 10,
  cookiesConfig: {
    localeCookieName: 'ascenda.locale',
    localeCookieDomain: 'stgeorge.com.au',
  },
  appId: '5abc938c-999a-4f59-a0c9-ea88b04d17f1',
  unleashAppName: 'rd-stg-prod',
  unleashClientKey:
    '*:production.ed9dc866a8362d926412ad673806fed91176182036fdca279f983b42',
};
